import { Link } from "react-router-dom";
import { circles } from "@/mocks/circles";

const themeMap = {
  primary: "bg-primary-100 text-primary-700",
  accent: "bg-accent-100 text-accent-700",
  secondary: "bg-secondary-100 text-secondary-800",
};

const iconBgMap = {
  primary: "bg-primary-500",
  accent: "bg-accent-500",
  secondary: "bg-secondary-500",
};

export default function CirclesSection() {
  const featured = circles.filter((c) => c.hot).slice(0, 4);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4">
          <div>
            <span className="text-xs font-medium tracking-widest text-accent-600">热门漫圈</span>
            <h2 className="mt-2 font-heading text-2xl md:text-4xl text-foreground-950">
              按作品和题材划分的漫圈
            </h2>
            <p className="mt-2 text-sm md:text-base text-foreground-600">
              找到和你同好的人，一起讨论剧情、分享心得，追漫不再孤单。
            </p>
          </div>
          <Link
            to="/circles"
            className="inline-flex items-center gap-1.5 whitespace-nowrap text-sm font-medium text-primary-600 hover:text-primary-500"
          >
            查看全部漫圈 <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {featured.map((c) => (
            <Link
              key={c.id}
              to="/circles"
              className="group rounded-2xl border border-background-200 bg-background-100 p-5 hover:-translate-y-1 hover:border-primary-300 transition-all"
            >
              <div className="flex items-center justify-between">
                <span className={`grid h-12 w-12 place-items-center rounded-2xl ${iconBgMap[c.theme]} text-background-50 text-xl shadow-sm`}>
                  <i className={c.icon} />
                </span>
                <span className="rounded-full bg-background-50 px-3 py-1 text-xs text-foreground-600">
                  {c.members} 人
                </span>
              </div>
              <h3 className="mt-4 font-heading text-lg text-foreground-950">{c.name}</h3>
              <p className="mt-2 text-xs md:text-sm leading-6 text-foreground-600 line-clamp-2">
                {c.description}
              </p>
              <div className="mt-4 flex items-center gap-1.5 text-xs text-foreground-700">
                <i className="ri-chat-3-line" />
                <span>{c.posts} 帖</span>
                <span className="ml-auto text-primary-600 group-hover:translate-x-1 transition-transform">
                  进圈看看 <i className="ri-arrow-right-s-line" />
                </span>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-6 flex flex-wrap items-center gap-2">
          <span className="text-xs text-foreground-500">热门标签：</span>
          {["热血", "悬疑", "恋爱", "科幻", "奇幻", "国漫", "声优", "绘画"].map((t) => (
            <span
              key={t}
              className={`rounded-full px-3 py-1 text-xs ${themeMap.primary}`}
            >
              #{t}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}